"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionalZoneValidationBase = void 0;
var core_1 = require("@inter-ikea-core/core");
var ValidationBase_1 = require("../validation/ValidationBase");
/**
 * A base for validating zones that iterates the hierarchy of the validated entity itself against the hierarchy of what it is
 * snapping to (or in the case of validating in place, the hierarchy it is placed in).
 *
 * You create your own validation by subclassing it and overriding the `checkZoneIntersectionOfOwnHierarchy` method.
 */
var FunctionalZoneValidationBase = /** @class */ (function (_super) {
    __extends(FunctionalZoneValidationBase, _super);
    function FunctionalZoneValidationBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FunctionalZoneValidationBase.prototype.validateCurrentState = function (entity) {
        return this.validate(entity);
    };
    FunctionalZoneValidationBase.prototype.validateSnap = function (snapActionCandidate) {
        return this.validate(snapActionCandidate.guestRoot, snapActionCandidate);
    };
    FunctionalZoneValidationBase.prototype.potentialParentIsAncestor = function (other, parentOfEntityToValidate) {
        if (parentOfEntityToValidate // We can't have a common ancestor if we have no parent
            && core_1.HierarchyUtils.findInHierarchy(other, function (it) { return it.id == parentOfEntityToValidate.id; })) // Parent is not an ancestor
            return true;
        return false;
    };
    FunctionalZoneValidationBase.prototype.getSnapRootHierarchy = function (entity) {
        var snapRoot = core_1.ComponentUtils.snapRoot(entity);
        if (snapRoot) {
            return core_1.HierarchyUtils.hierarchy(snapRoot);
        }
        else {
            return core_1.HierarchyUtils.hierarchy(entity);
        }
    };
    FunctionalZoneValidationBase.prototype.validate = function (entity, snapActionCandidate) {
        var _a;
        // Find the root of the scene or, in case of snapping, the root of the tree the entity tries
        // to snap to
        var root = this.findRoot(snapActionCandidate, entity);
        // We need to check the snapping entity and all its descendants
        var hierarchy = this.getSnapRootHierarchy(entity);
        // In case we're snapping to a new parent, then we use that. If we're not snapping, use current parent
        var snapParent = (_a = snapActionCandidate === null || snapActionCandidate === void 0 ? void 0 : snapActionCandidate.host) !== null && _a !== void 0 ? _a : core_1.HierarchyUtils.parent(entity);
        var rootHierarchy = core_1.HierarchyUtils.hierarchy(root);
        var result = null;
        var myHierarchyIndex = 0;
        var finishedAll = false;
        // Loop over all entities in the entity's hierarchy
        while (!finishedAll) {
            var currentEntity = hierarchy[myHierarchyIndex];
            var rootHierarchyIndex = 0;
            // Loop over all entities in the root hierarchy (i.e. scene or whatever hierarchy we evaluate against)
            var finishedCurrent = false;
            while (!finishedCurrent) {
                var other = rootHierarchy[rootHierarchyIndex];
                result = this.checkZoneIntersectionOfOwnHierarchy(hierarchy, currentEntity, other, snapParent);
                rootHierarchyIndex++;
                // If we found a warning or searched the entire hierarchy, then we're finished
                finishedCurrent = !(result == null && rootHierarchyIndex < rootHierarchy.length);
            }
            myHierarchyIndex++;
            finishedAll = !(result == null && myHierarchyIndex < hierarchy.length);
        }
        return result;
    };
    return FunctionalZoneValidationBase;
}(ValidationBase_1.ValidationBase));
exports.FunctionalZoneValidationBase = FunctionalZoneValidationBase;
//# sourceMappingURL=FunctionalZoneValidationBase.js.map